import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RfiRequestComponent } from "./rfi-request/rfi-request.component";
import { RfiResponseComponent } from "./rfi-response/rfi-response.component";
import { GeneralResponseComponent } from "./general-response/general-response.component";

@Component({
  selector: 'app-clarification-design',
  standalone: true,
  imports: [MatIconModule, RfiRequestComponent, RfiResponseComponent, GeneralResponseComponent],
  templateUrl: './clarification-design.component.html',
  styleUrl: './clarification-design.component.css'
})
export class ClarificationDesignComponent {
}
